// ----------------------------------------------------------------------------

function getFieldCount(element: HTMLElement): number {
    let columnCount = 0;
    const elTableHead = element.querySelector('thead');

    if (elTableHead?.rows.length) {
        columnCount = elTableHead.rows[0].cells.length;
    }

    return columnCount;
}

// ----------------------------------------------------------------------------

export default getFieldCount;
